import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import { customStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';

function BuildingComponentModal({
  history,
  getList,
  showData,
  type,
  createData,
  updateData,
  updateList,
  id,
  getOrdinanceRevisionList,
  ordinanceRevisionList,
  ordinanceRevisionId,
}) {

  const [formData, setFormData] = useState({
    depreciation_rate: '',
    from: '',
    to: '',
    ordinance_revision_id: ordinanceRevisionId,

  });
  const validateForm = useFormValidator(formData, {
    depreciation_rate: 'required',
    from: 'required',
    to: 'required',
    ordinance_revision_id: 'required',
  });

  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    const isChecked = e.target.checked ? 1 : 0;
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? isChecked : e.target.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (type === 'NEW') {
      createData(formData, (data) => {
        setModal({ isOpen: false });
        history.push(`/rpt/building/settings/depreciation-rates/${data.data.id}`);
        getList();
        showData(data.data.id)
      });
    }

    if (type === 'EDIT') {
      updateData(id, formData, (data) => {
        setModal({ isOpen: false });
        history.push(`/rpt/building/settings/depreciation-rates/${data.data.id}`);
        getList();
        showData(data.data.id)
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);
  const onSetFormData = () => {
    setFormData({
      depreciation_rate: _.get(updateList, 'depreciation_rate') || '',
      from: _.get(updateList, 'from') || '',
      to: _.get(updateList, 'to') || '',
      ordinance_revision_id: _.get(updateList, 'ordinance_revision_id') || ''
    });
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  useEffect(() => {
    if (_.isEmpty(ordinanceRevisionList)) getOrdinanceRevisionList();
  }, []);

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        name: data.attributes.name,
        year_from: data.attributes.year_from,
        year_to: data.attributes.year_to,
        value: data.id,
      });
    });
    return newList;
  };

  const onRenderOption = (item) => {
    return (
      <table>
        <tbody>
          <tr>
            <td style={{ width: 250 }}>{item.name}</td>
            <td className="text-right" style={{ width: 100 }}>
              {item.year_from} - {item.year_to}{' '}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  const handleOrdinanceSelect = (e) => {
    setFormData({
      ...formData,
      ordinance_revision_id: e.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Depreciation Rate {validateForm.renderMessage('depreciation_rate')}
            </label>
            <input
              className="form-control"
              type="number"
              name="depreciation_rate"
              onChange={onChange}
              value={_.get(formData, 'depreciation_rate')}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              From {validateForm.renderMessage('from')}
            </label>
            <input
              className="form-control"
              type="number"
              name="from"
              onChange={onChange}
              value={_.get(formData, 'from')}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              To {validateForm.renderMessage('to')}
            </label>
            <input
              className="form-control"
              type="number"
              name="to"
              onChange={onChange}
              value={_.get(formData, 'to')}
            />
          </div>
          <div className='col-12 form-group'>
            <label htmlFor="last_name" className="form-label mb-0">
              Ordinance Revision{' '}
              {validateForm.renderMessage('ordinance_revision_id')}
            </label>
            <Select
              options={createDropdown(ordinanceRevisionList)}
              styles={customStyle}
              placeholder="Select Ordinance"
              isDisabled
              value={
                createDropdown(ordinanceRevisionList).filter(
                  (item) =>
                    +_.get(formData, 'ordinance_revision_id') ===
                    +_.get(item, 'value')
                ) || ''
              }
              onChange={(e) => {
                handleOrdinanceSelect(e);
              }}
              formatOptionLabel={onRenderOption}
            />
          </div>
        </div>
        <hr className="below-hr" />
        <div className="d-flex justify-content-center">
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark mr-3"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

BuildingComponentModal.defaultProps = {
  type: '',
  updateList: {},
  id: '',
  ordinanceRevisionId: null,
};

BuildingComponentModal.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  ordinanceRevisionId: PropTypes.number,
  updateList: PropTypes.instanceOf(Object),
  createData: PropTypes.instanceOf(Function).isRequired,
  updateData: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(BuildingComponentModal);
